export default __webpack_public_path__ + "static/media/Operação (Real Size).2f11ac1d.svg";